import moment from 'moment';
import React from 'react';
import {useSelector} from 'react-redux';
import {Button, Card, Modal, Table} from 'semantic-ui-react';
import {dateFormatShow} from '../../../common/constants/datesFormat';

const EtaManagementDetailModal = ({showRowDetailModal, setShowRowDetailModal, selected}) => {
  const {detail} = useSelector((state) => state.dealerOrdersEtaManagement);
  return (
    <Modal closeIcon size='fullscreen' onClose={() => setShowRowDetailModal(null)} open={showRowDetailModal} >
      <Modal.Header><h2>Detalle de atención ABIS</h2></Modal.Header>
      <Modal.Content>
        {/* <Container style={{'marginLeft': '0px !important', 'marginBottom': '20px'}}>
          <Card fluid>
            <Step.Group ordered>
              <Step completed>
                <Step.Content>
                  <Step.Title>Ingresado</Step.Title>
                  <Step.Description>Pedido ingresado en la fuente</Step.Description>
                </Step.Content>
              </Step>

              <Step>
                <Step.Content>
                  <Step.Title>Procesado</Step.Title>
                  <Step.Description>Pedido procesado en la fuente</Step.Description>
                </Step.Content>
              </Step>

              <Step>
                <Step.Content>
                  <Step.Title>En Espera</Step.Title>
                  <Step.Description>Los ETAs fueron asignados a todas líneas de atención en ABIS</Step.Description>
                </Step.Content>
              </Step>

              <Step>
                <Step.Content>
                  <Step.Title>Embarcado</Step.Title>
                  <Step.Description>Todas las líneas de atención ABIS tienen fecha de embarque</Step.Description>
                </Step.Content>
              </Step>
              
            </Step.Group>
          </Card>
        </Container> */}
        <div className='dealer-orders-tracking-schedule'>
          <Card raised fluid className='tracking-body'>
            <div style={{'overflow': 'auto'}}>
              {
                detail.length === 0 ?
                  <Table className='full-table'>
                    <Table.Row>
                      <Table.Cell>
                        <h3>No se encuentra ninguna atención en ABIS para el elemento seleccionado</h3>
                      </Table.Cell>
                    </Table.Row>
                  </Table> :
                  <Table className='full-table'>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell>ord_start_date</Table.HeaderCell>
                        <Table.HeaderCell>order_no</Table.HeaderCell>
                        <Table.HeaderCell>prc_p_no</Table.HeaderCell>
                        <Table.HeaderCell>prc_part_name</Table.HeaderCell>
                        <Table.HeaderCell>org_p_no</Table.HeaderCell>
                        <Table.HeaderCell>ord_qty</Table.HeaderCell>
                        <Table.HeaderCell>prc_qty</Table.HeaderCell>
                        <Table.HeaderCell>cancel_qty</Table.HeaderCell>
                        <Table.HeaderCell>shipped_qty</Table.HeaderCell>
                        <Table.HeaderCell>status</Table.HeaderCell>
                        <Table.HeaderCell>qty</Table.HeaderCell>
                        <Table.HeaderCell>etd</Table.HeaderCell>
                        <Table.HeaderCell>invoice_no</Table.HeaderCell>
                        <Table.HeaderCell>ship_date</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      {
                        detail.map((item, i) => {
                          return (
                            <Table.Row key={`ro-${i}`}>
                              <Table.Cell>{item?.ord_start_date &&
                                moment(item?.ord_start_date).format(dateFormatShow)}</Table.Cell>
                              <Table.Cell>{item?.order_no}</Table.Cell>
                              <Table.Cell>{item?.prc_p_no}</Table.Cell>
                              <Table.Cell>{item?.prc_part_name}</Table.Cell>
                              <Table.Cell>{item?.org_p_no}</Table.Cell>
                              <Table.Cell>{item?.ord_qty}</Table.Cell>
                              <Table.Cell>{item?.prc_qty}</Table.Cell>
                              <Table.Cell>{item?.cancel_qty}</Table.Cell>
                              <Table.Cell>{item?.shipped_qty}</Table.Cell>
                              <Table.Cell>{item?.status}</Table.Cell>
                              <Table.Cell>{item?.qty}</Table.Cell>
                              <Table.Cell>{item?.etd &&
                                moment(item?.etd).format(dateFormatShow)}</Table.Cell>
                              <Table.Cell>{item?.invoice_no}</Table.Cell>
                              <Table.Cell>{item?.ship_date &&
                                moment(item?.ship_date).format(dateFormatShow)}</Table.Cell>
                            </Table.Row>
                          );
                        })
                      }
                    </Table.Body>
                  </Table>
              }
            </div>
          </Card>
        </div>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={() => setShowRowDetailModal(null)}>Cerrar</Button>
      </Modal.Actions>
    </Modal>
  );
};

export default EtaManagementDetailModal;
